var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bool-checkbox',{staticClass:"check-all-component",attrs:{"disabled":_vm.disabled,"text":_vm.text},on:{"changed":_vm._changedSelection},model:{value:(_vm.isEquals),callback:function ($$v) {_vm.isEquals=$$v},expression:"isEquals"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }